module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-03c62800.png";